<template>
    <div class="wb-project-price" v-on:click.stop="method()">
        <div class="wb-project-price-list-ico-anchor">
            <div class="wb-project-price-list-ico">
                <SVGList/>
            </div>
        </div>
        <input class="wb-project-price-input"
               type="text"
               ref="name"
               :value="value + ' ' + this.currencySymbol"
               readonly>
        <div class="wb-project-price-changer-anchor">
            <div class="wb-project-price-changer">
                <SVGArrowUp v-if="isListOpened"/>
                <SVGArrowDown v-else/>
            </div>
        </div>
    </div>
</template>

<script>
import SVGList from '@/UI/Components/SVG/SVGList.vue';
import SVGArrowDown from '@/UI/Components/SVG/SVGArrowDown.vue';
import SVGArrowUp from '@/UI/Components/SVG/SVGArrowUp.vue';

export default {
    name: 'NavbarProjectPrice',
    inject: ['currencySymbol'],
    components: {
        SVGArrowUp,
        SVGArrowDown,
        SVGList,
    },
    props: [
        'valueProp',
        'isListOpened',
        'method',
    ],
    computed: {
        value() {
            if (this.valueProp) {
                return this.valueProp;
            }
            return 0;
        },
    },
};
</script>

<style scoped lang="scss">
@import "CSS/common.scss";
@import "CSS/colors.scss";
@import "CSS/fonts.scss";
@import "CSS/animations.scss";

.wb-project-price {
    display: flex;
    flex-direction: row;
    height: 40px;
    padding: 0 32px;
    cursor: pointer;
}

.wb-project-price-list-ico-anchor {
    position: relative;
    width: 0;
}

.wb-project-price-list-ico {
    position: absolute;
    left: 8px;
    width: 36px;
    height: 100%;
    user-select: none;
    display: flex;
    color: $gray3;
    @include wb-c-flex-center;
    @include button-smooth;
}

.wb-project-price-input {
    padding: 0 48px 0 48px;
    vertical-align: center;
    height: 100%;
    box-sizing: border-box;
    outline: none;
    border: none;
    color: $darkBlue;
    cursor: pointer;
    //background-color: $gray1;
    background-color: $white;
    border-radius: 4px;
    @include font-h1;
    @include button-smooth;

    width: 192px;
}

.wb-project-price-input-active {
    background-color: $white;
}

.wb-project-price-changer-anchor {
    position: relative;
    width: 0;
}

.wb-project-price-changer {
    position: absolute;
    left: -44px;
    width: 36px;
    height: 100%;
    display: flex;
    color: $gray3;
    @include wb-c-flex-center;
    @include button-smooth;
}
</style>
